import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {LanguageService} from '@core/services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  title = 'red-sea-frontend';
  constructor(private languageService: LanguageService) {
  }

  ngOnInit(): void {
    this.setAppDefaultLang();
     
  }

  private setAppDefaultLang() {
    this.languageService.setInitialAppLanguage()
  }
}
